import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../core/services/Singleton";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { _EmployeeContract, _FunctionalArea, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { SelectFunctionalArea } from "../../../admin/configuracion/FunctionalArea/SelectFunctionalArea";
import { Modal } from "../../../theme/Component/Modal";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { InputDate } from "../../../theme/Input/InputDate";
import { AccountEditor } from "../../../editor/AccountEditor";
import { toast } from "react-toastify";
import { PayrollTypeSelect } from "../../ParametrosTalentoHumano/PayrollFactor/PayrollTypeSelect";
import { AppointmentCatalog } from "../../ParametrosTalentoHumano/Appointment/AppointmentCatalog/AppointmentCatalog";
import { Alert } from "../../../theme/Component/Alert";
import { EditEmployeeContract } from "../EmployeeContract/EditEmployeeContract";
import { PrintJson } from "../../../theme/Component/PrintJson";


type beanContract = {
    IDAccount?: number;
    IDLnFunctionalArea?: number;
    IDAppointment?: number;
    IDEntailment?: number;
    IDEmployeeContractType?: number;
    IDEmploymentType?: number;
    IDPayrollType?: number;
    [key: string]: any;
}

interface CreateEmployeeContractProps {
    isModal?: boolean;
    onChange?: Function;
    beanData?: beanContract;
}

export const CreateEmployeeContract = ({ isModal, onChange, beanData }: CreateEmployeeContractProps) => {

    const functionalArea = useDataBean(_FunctionalArea);
    const employeeContract = useDataBean(_EmployeeContract);
    const single = Singleton.getInstance();
    const [plaza, setPlaza] = useState<any>({});
    const [bean, setBean] = useState<any>({});
    const [missingFields, setMissingFields] = useState<string[]>([]);
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalUpdate, setModalUpdate] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    const [step, setStep] = useState(1);
    const [employee, setEmployee] = useState<any>({});
    const [contract, setContract] = useState<any>([]);

    const PLAZA_ASIGNADA = 4;

    const applyPlazaToBean = (selectedPlaza: any) => {
        if (!selectedPlaza?.IDLn) return;

        setPlaza(selectedPlaza);
        setBean((prev: any) => ({
            ...prev,
            IDAppointment: selectedPlaza.IDAppointment ?? prev.IDAppointment,
            IDEntailment: selectedPlaza.IDEntailment ?? prev.IDEntailment,
            IDEmployeeContractType: selectedPlaza.IDEmployeeContractType ?? prev.IDEmployeeContractType,
            IDEmploymentType: selectedPlaza.IDEmploymentType ?? prev.IDEmploymentType,
            IDLnFunctionalArea: selectedPlaza.IDLn,
            IDPayrollType: selectedPlaza.IDPayrollType ?? prev.IDPayrollType,
            Revenue: selectedPlaza.Salary ?? prev.Revenue,
            IDAccount: employee.IDAccount ?? prev.IDAccount,
            IDEmployee: single.getAccountID(),
        }))

        if (selectedPlaza.IDContract != null) {
            setModal((prev: any) => ({ ...prev, "view": true, "name": "Advertencia" }))
        }
    }

    useEffect(() => {
        const initialBean = {
            IDEmployee: _single.getAccountID(),
            ...(beanData ?? {})
        };

        setBean(initialBean);

        if (beanData?.IDAccount) {
            setEmployee((prev: any) => ({
                ...prev,
                IDAccount: beanData.IDAccount
            }));
        }
    }, [beanData?.IDAccount, beanData?.IDLnFunctionalArea, beanData?.IDAppointment])

    useEffect(() => {
        if (employee.IDAccount) {
            getEmployeeContract(employee.IDAccount);
        }
    }, [employee])


    const getEmployeeContract = (idAccount: number) => {
        employeeContract.instance.getEmployeeContracts(_single.getCurrenYear(), _single.getCurrentMonth(), [idAccount], null, null, null, null, 2, null, null, 1, 100).then(
            (resp: any) => {
                console.log(resp);
                if (resp.List) {
                    if (Array.isArray(resp.List)) {
                        if (resp.List.length == 0)
                            setStep(2);
                    }
                    setContract(resp.List);
                }
            }
        )
    }

    const createContrac = () => {
        employeeContract.instance.updateEmployeeContract(bean).then(
            (resp) => {
                toast.success("Contrato Creado Exitosamente");
                setModalUpdate({ ...modalUpdate, "view": true, "name": "Crear Nuevo Contrato Laboral" });
                console.log(resp);
                let contract = { ...resp, IDEmployeeContractType: plaza.IDEmployeeContractType };
                contract.CostingCenter = resp.CostingCenterCode;
                contract.UseOwnCostingCenter = true;
                setBean(contract);
                onChange?.(contract);
                updatePlaza();
            }
        );
    }
    const updatePlaza = () => {
        functionalArea.updateCustonBean({ ...plaza, State: PLAZA_ASIGNADA }).then(
            (resp: any) => {
                functionalArea.instance.getFunctionalArea(plaza.IDLn).then(
                    (resp) => {

                        console.log("PLAZA LABORAL => ", resp);
                        setPlaza(resp);
                    });
            }
        )
    }

    const updateContract = () => {

        if (bean.IDPayrollType > 0) {
            employeeContract.instance.updateEmployeeContract(bean).then(
                (resp) => {
                    setBean(resp);
                    toast.success("Contrato Actualizado Exitosamente");
                    setModalUpdate({ ...modalUpdate, "view": false, "name": "Crear Nuevo Contrato Laboral" });
                }
            )

        } else {
            toast.warning("Payroll es obligatorio");
        }

    }

    const update = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            setModal({ ...modal, "view": false })
            createContrac();
        }
    };

    const isEmpty = (value: any) => {
        return value === null || value === undefined || (typeof value === "string" && value.trim() === "");
    }

    const isInvalidID = (value: any) => {
        return isEmpty(value) || Number(value) <= 0;
    }

    const validateForm = () => {
        const missing = [];

        if (isEmpty(bean.InitContract)) missing.push("InitContract");
        if (isInvalidID(bean.IDAccount)) missing.push("IDAccount");
        if (isInvalidID(bean.IDAppointment)) missing.push("IDAppointment");
        if (isInvalidID(bean.IDEntailment)) missing.push("IDEntailment");
        if (isInvalidID(bean.IDPayrollType)) missing.push("IDPayrollType");
        if (isInvalidID(bean.IDLnFunctionalArea)) missing.push("IDLn");

        setMissingFields(missing);
        return missing.length
    };

    const enableUpdate = () => {
        return !isInvalidID(bean.IDAccount)
            && !isInvalidID(bean.IDLnFunctionalArea)
            && !isInvalidID(bean.IDEntailment)
            && !isInvalidID(bean.IDPayrollType)
            && !isEmpty(bean.InitContract);
    }

    const componentRender = () => {
        return (
            <>
                <div className="row">
                    <div className="col-md-4">
                        <div className="row">
                            <div className="col-md-12">
                                <h5>Formulario</h5>
                                <hr />
                            </div>
                            <div className="col-md-12">
                                {step == 1 &&
                                    <div className="row">
                                        <div className="com-md-3">
                                            <label className={`${missingFields.includes('IDAccount') ? 'has-error' : ''}`} >Empleado</label>
                                            <AccountEditor label=" " idAccount={bean.IDAccount} onChange={(e) => { setEmployee(e); setBean((prev: any) => ({ ...prev, "IDAccount": e.IDAccount })) }} />
                                        </div>

                                    </div>
                                }
                                {step == 2 &&
                                    <div className="row mb-4">
                                        <div className="col-md-12">
                                            <label className={`${missingFields.includes('InitContract') ? 'has-error' : ''}`}>Fecha de Inicio de Contrato</label>
                                            <InputDate name="InitContract" value={bean.InitContract} notDate={true} setDate={(e) => { setBean((prev: any) => ({ ...prev, "InitContract": e })) }} />
                                        </div>
                                        <div className="col-md-12">
                                            <label className={`${missingFields.includes('IDLn') ? 'has-error' : ''}`} >Plaza Laboral</label>
                                            <SelectFunctionalArea value={bean.IDLnFunctionalArea} label=" " onChange={applyPlazaToBean} />
                                        </div>
                                        <div className="col-md-12">
                                            <label className={`${missingFields.includes('IDAppointment') ? 'has-error' : ''}`}>Nivel Salarial</label>
                                            <AppointmentCatalog disable={plaza.IDAppointment} idSelector={bean.IDAppointment} onChange={(e) => { setBean((prev: any) => ({ ...prev, "IDAppointment": e.IDAppointment, "AppointmentName": e.Name })) }} label=" " returnType="Object" />
                                        </div>
                                        <div className="col-md-12">
                                            <PayrollTypeSelect idSelector={bean.IDPayrollType} onChange={(e) => { setBean((prev: any) => ({ ...prev, "IDPayrollType": e })) }} />
                                        </div>
                                        <div className="col">
                                            <BasicButton disable={!enableUpdate()} useMargin icon="ri-task-line" eventClick={update} >Crear Contrato</BasicButton>
                                            <BasicButton disable={!bean.IDContract} useMargin icon="ri-task-line" eventClick={() => {
                                                setModalUpdate({ ...modalUpdate, "view": true, "name": "Contrato Laboral" });
                                            }} >Editar Contrato</BasicButton>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="col-md-8">
                        <div className="row">
                            <div className="col-md-12">
                                {employee.IDAccount &&
                                    <>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h5>Empleado</h5>
                                                <hr />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <label>Identificación</label>
                                                <input type="text" name="Name" readOnly className="form-control" value={employee.Nit} />
                                            </div>
                                            <div className="col-md-6">
                                                <label>Nombre</label>
                                                <input type="text" name="Name" readOnly className="form-control" value={employee.EntityName} />
                                            </div>
                                            <div className="col-md-6">
                                                <label>Correo</label>
                                                <input type="text" name="Name" readOnly className="form-control" value={employee.eMail} />
                                            </div>
                                            <div className="col-md-6">
                                                <label>Telefono</label>
                                                <input type="text" name="Name" readOnly className="form-control" value={employee.Tel} />
                                            </div>
                                            {/* <PrintJson json={employee}/> */}
                                        </div>
                                    </>
                                }
                                {contract.length > 0 &&
                                    <div className="row">
                                        {contract.map((item) => {
                                            return (
                                                <div className="col-md-12">
                                                    <div className="row">
                                                        <div className="col-md-12 mt-4">
                                                            <h5>Contratos Activos</h5>
                                                            <hr />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <label>Contrato ID</label>
                                                            <input type="text" name="Name" readOnly className="form-control" value={item.DataBeanProperties.IDContract} />
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label>Fecha Inicial</label>
                                                            <input type="text" name="Name" readOnly className="form-control" value={item.DataBeanProperties.InitContract} />
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label>Salario</label>
                                                            <input type="text" name="Name" readOnly className="form-control" value={item.DataBeanProperties.Revenue} />
                                                        </div>
                                                        <div className="col-md-12">
                                                            <label>Area</label>
                                                            <input type="text" name="Name" readOnly className="form-control" value={item.DataBeanProperties.FunctionalIDName} />
                                                        </div>
                                                        <div className="col-md-12">
                                                            <label>Nivel Salarial</label>
                                                            <input type="text" name="Name" readOnly className="form-control" value={item.DataBeanProperties.AppointmentName} />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                        <div className="col-md-12">
                                            <Alert clase="warning">
                                                <p>
                                                    El usuario tiene contratos activos, no puede ser creado un nuevo contrato. <br />
                                                    <small>Valide en el Historial de Contratos.</small>
                                                </p>
                                            </Alert>
                                        </div>

                                    </div>

                                }
                                {plaza.IDLn &&
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-12 mt-4">
                                                    <h5>Plaza Laboral</h5>
                                                    <hr />
                                                </div>
                                                <div className="col-md-6">
                                                    <label>Nombre</label>
                                                    <input type="text" name="Name" readOnly className="form-control" value={plaza.Description} />
                                                </div>
                                                <div className="col-md-6">
                                                    <label>Area</label>
                                                    <input type="text" name="Name" readOnly className="form-control" value={plaza.FunctionalIDName} />
                                                </div>
                                                <div className="col-md-12">
                                                    <label>Nivel Salarial</label>
                                                    <input type="text" name="Name" readOnly className="form-control" value={plaza.AppointmentName} />
                                                </div>
                                                <div className="col-md-4">
                                                    <label>Salario</label>
                                                    <input type="text" name="Name" readOnly className="form-control" value={plaza.Salary} />
                                                </div>
                                                <div className="col-md-4">
                                                    <label>Estado</label>
                                                    <input type="text" name="Name" readOnly className="form-control" value={plaza.StateName} />
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>

                <Modal modal={modal} updateModal={setModal}  >
                    <div >
                        <label>
                            La Plaza actual esta ocupada por: <br />
                            {plaza.Nit} - {plaza.Name1 ?? ""} {plaza.Name2 ?? ""} {plaza.Surname1 ?? ""} {plaza.Surname2 ?? ""} <br />
                            Hasta la fecha: {plaza.UptoContract ? plaza.UptoContract.slice(0, 10) : ""}
                        </label>
                        <div className="col-12">
                            <label className={`${missingFields.includes('InitContract') ? 'has-error' : ''}`} >Empleado</label>
                            <AccountEditor label=" " idAccount={bean.IDAccount} onChange={(e) => { setBean((prev: any) => ({ ...prev, "IDAccount": e.IDAccount })) }} />
                        </div>
                        <div className="col-12">
                            <label className={`${missingFields.includes('InitContract') ? 'has-error' : ''}`}>Fecha de Inicio de Contrato</label>
                            <InputDate name="InitContract" value={bean.InitContract} notDate={true} setDate={(e) => { setBean((prev: any) => ({ ...prev, "InitContract": e })) }} />
                        </div>
                        <div className="row mt-2">
                            <div className="col-6">
                                <BasicButton icon="" clase="success" eventClick={() => { update() }} >Continuar</BasicButton>
                            </div>
                            <div className="col-6 d-flex justify-content-end">
                                <BasicButton eventClick={() => { setPlaza({}); setModal({ ...modal, "view": false }) }} icon="" clase="danger"  >Cancelar</BasicButton>
                            </div>
                        </div>
                    </div>
                </Modal>

                <Modal modal={modalUpdate} updateModal={setModalUpdate} eventModal={() => { updateContract() }}  >
                    <EditEmployeeContract bean={bean} setBean={setBean} />
                </Modal>
            </>
        )
    }

    return isModal ? componentRender() :
        (
            <BasicPage titulo="Crear Nuevo Contrato de Trabajo">
                {componentRender()}
            </BasicPage>
        )
}
